export default __webpack_public_path__ + "static/dashboard-thumb-5-084af3424fc453fd90029199fd44362c.webp";